<!-- BANNER
        ================================================== -->

<!--<ng-template #news>

    <div class="card shadow-xl border rounded-3xl overflow-hidden">
        &lt;!&ndash; Card Header &ndash;&gt;
       &lt;!&ndash; <div class="card-header ">
            <h3 class="text-xl font-semibold tracking-wide icon">Latest News
                <i class="fa fa-times text-md-end cursor-pointer transition duration-200" style="float: right"
                   (click)="closeModal()"></i>
            </h3>
        </div>&ndash;&gt;
        <div class="card-header bg-gradient-to-r from-blue-600 to-indigo-500 text-white  flex justify-between items-center">
            <h3 class="text-xl font-semibold tracking-wide flex items-center gap-2 icon">
                <i class="fa fa-newspaper"></i> &lt;!&ndash; FontAwesome icon for Latest News &ndash;&gt;
                Latest News
                <i class="fa fa-times text-md-end cursor-pointer transition duration-200" style="float: right"
                   (click)="closeModal()">
                </i>
            </h3>
        </div>
        &lt;!&ndash; Card Body &ndash;&gt;
        <div class="card-body bg-gray-50 px-6 py-6" style="overflow-y: auto; max-height: 400px;">
            <div id="defaultnews" class="grid gap-6">
                &lt;!&ndash; Single News Item &ndash;&gt;
                <div *ngFor="let item of newsData"
                     class="flex gap-4 items-center bg-white border border-gray-200 rounded-xl p-5 shadow-sm hover:shadow-md transition duration-200" style="margin-bottom: 10px;">
                    &lt;!&ndash; News Content &ndash;&gt;
                    <div class="flex-grow">
                        <h3 class="text-lg font-bold bg-blue-50 text-blue-800  rounded-md mb-2">
                            <i class="fa fa-file text-sm-start " style="margin-right: 10px; color: #b02a37; font-size: 24px"></i>
                            <a href="#" class="text-blue-800 hover:text-blue-600 transition duration-200">{{ item?.title | titlecase }}</a>
                        </h3>
                        <p class="text-gray-700 text-sm mb-3 line-clamp-3">
                            {{ item?.description | titlecase }}
                        </p>
                        <div class="flex  text-sm text-gray-500 mb-3">
                            <span style="float: right">
                                <i class="fa fa-calendar zmdi-calendar-check mr-2" style="margin-right: 10px;"></i>
                                {{ item?.date }}
                            </span>
                        </div>
                        <button *ngIf="item?.file != null"
                                class="btn btn-outline-blue-600 btn-sm hover:shadow-md transition duration-200"
                                (click)="goTo(item?.file?.url)">
                            Check Now
                        </button>
                    </div>
                </div>
            </div>
        </div>
        &lt;!&ndash; Card Footer &ndash;&gt;
        <div class="card-footer bg-gray-100 px-6 py-4 flex justify-end">
            <button class="btn btn-primary px-6 py-2 text-sm rounded-lg shadow-md hover:shadow-lg transition duration-200"
                (click)="goTo('news')">Read More
            </button>
        </div>
    </div>
</ng-template>-->

<ng-template #news>
    <!--  <div class="card">
          <div class="card-header">
              <div class="row">
                  <div class="col-11 float-start"><b>Latest News</b></div>
                  <div class="col-1 float-end"><i class="fa fa-window-close text-danger fs-4 cursor-pointer"
                                                  (click)="closeModal()"></i></div>
              </div>
          </div>
          <div class="card-body">
              <div class="row" id="defaultnews" style="color: white;overflow-y: scroll;height: 600px;">
                  <div class="col-md-12 mb-3" *ngFor="let item of newsData;">
                      <div class="single-latest-item p-3 border-radius-10" style="background-color: #254f7cde;">
                          <div class="single-latest-image"><a href="#"></a></div>
                          <div class="single-latest-text" style="color: black;">
                              <img src="assets/img/hostel/news.gif" alt="" class="img img-thumbnail" style="width:100px">
                              <h3><a href="#" class="text-secondary">{{ item?.title }}</a></h3>
                              <div class="single-item-comment-view text-white"><span><i
                                  class="zmdi zmdi-calendar-check"></i>{{ item?.date }}</span>
                              </div>
                              <p class="text-white">{{ item?.description }}</p>
                              <p class="text-white cursor-pointer btn btn-outline-secondary" *ngIf="item?.file != null"
                                 (click)="goTo(item?.file?.url)">Check Now </p>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="card-footer">
              <button class="btn btn-primary btn-sm" (click)="goTo('news')">Learn More</button>
          </div>
      </div>-->

    <div class="card">
        <div class="card-header bg-primary text-white">
            <div class="row">
                <div class="col-10 float-start">
                    <b>Latest Information & Admission Helpline No. <a href="tel:9015909622"
                                                                      class="text-white rounded px-1 blinking-text">9015909622</a></b>
                </div>
                <div class="col-2  ">
                    <i class="fa fa-window-close text-danger fs-4 cursor-pointer float-end" (click)="closeModal()"></i>
                </div>
            </div>
        </div>
        <div class="card-body" style="height: 400px;">
            <div class="container">
                <img src="assets/img/popup_image.jpg" class="cover-background cursor-pointer"
                     (click)="goTo('assets/img/popup_image.jpg')"/>
            </div>
        </div>
        <div class="card-footer bg-primary text-end">
            <!--            <div class="d-flex justify-content-center mt-3 gap-3">-->
            <div class="row ">
                <div class="col-md-4 col-sm-12 ">
                    <button class="btn text-white btn-sm float-start w-100 mb-2" style="background: #ff7029;"
                            (click)="goTo('enquiry')">
                        ADMISSION ENQUIRY
                    </button>
                </div>
                <div class="col-md-4 col-sm-12">
                    <button class="btn text-white btn-sm w-100 mb-2" style="background: #ff7029;"
                            (click)="goTo('conference')">
                        INTERNATIONAL CONFERENCE
                    </button>
                </div>
                <div class="col-md-4 col-sm-12">
                    <button class="btn btn-primary btn-sm border-0 w-100 mb-2" (click)="goTo('news')"
                            style="background: #ff7029;">
                        Learn More
                    </button>
                </div>
            </div>
            <!--            </div>-->
        </div>
    </div>


</ng-template>

<section class="top-position-banner p-0">
    <div class="container-fluid px-0">
        <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
            <div class="carousel-indicators">
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active"
                        aria-current="true"></button>
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1"></button>
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2"></button>
            </div>
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <div
                        class="item bg-img cover-background pt-6 pb-10 pt-sm-6 pb-sm-14 py-md-16 py-lg-20 py-xxl-24 left-overlay-dark"
                        data-overlay-dark="8" data-background="assets/img/banner/slide1.jpg"
                        style="background-image: url('assets/img/banner/banner_1.jpg');">
                        <div class="container pt-6 pt-md-0">
                            <div class="row align-items-center">
                                <div
                                    class="col-md-12 col-lg-12 col-xl-12 mb-1-9 mb-lg-0 py-6 position-relative text-center">
                                    <h1 class="display-1 font-weight-800 mb-2-6 title text-white text-uppercase">
                                        Empower Your Dreams at ARNI University
                                    </h1>
                                    <span class="h5 text-secondary">Where Education Meets Excellence – Join a community of innovators, leaders, and achievers.</span>
                                    <p class="mt-3 w-sm-100">
                                        <button class="custom-bannar-btn btn-15 text-nowrap w-25 w-sm-100 py-2"
                                                (click)="goToUrl('/enquiry')"><i class="fa fa-arrow-right"></i> Apply
                                            Now
                                        </button>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="carousel-item">
                    <div
                        class="item bg-img cover-background pt-6 pb-10 pt-sm-6 pb-sm-14 py-md-16 py-lg-20 py-xxl-24 left-overlay-dark"
                        data-overlay-dark="8" data-background="assets/img/banner/slide2.jpg"
                        style="background-image: url('assets/img/banner/banner_2.jpg');">
                        <div class="container pt-6 pt-md-0">
                            <div class="row align-items-center">
                                <div
                                    class="col-md-12 col-lg-12 col-xl-12 mb-1-9 mb-lg-0 py-6 position-relative text-center">
                                    <h1 class="display-1 font-weight-800 mb-2-6 title text-white text-uppercase">Learn
                                        Beyond the Classroom</h1>
                                    <span class="h5 text-secondary">Gain practical knowledge, real-world exposure, and a career-ready mindset.</span>
                                    <p class="mt-3 w-sm-100">
                                        <button class="custom-bannar-btn btn-15 text-nowrap w-25 w-sm-100 py-2"
                                                (click)="goToUrl('/enquiry')"><i class="fa fa-arrow-right"></i> Apply
                                            Now
                                        </button>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators"
                    data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators"
                    data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
            </button>
        </div>
    </div>
    <div class="triangle-shape top-15 right-10 z-index-9 d-none d-md-block"></div>
    <div class="square-shape top-25 left-5 z-index-9 d-none d-xl-block"></div>
    <div class="shape-five z-index-9 right-10 bottom-15"></div>
</section>


<!-- INFORMATION
       ================================================== -->
<section class="p-0 overflow-visible service-block pb-5">
    <div class="container">
        <div class="row mt-n1-9">
            <div class="col-md-6 col-lg-4 mt-1-9">
                <div class="card card-style3 h-100">
                    <div class="card-body px-1-9 py-2-3">
                        <div class="mb-3 d-flex align-items-center">
                            <div class="card-icon">
                                <i class="ti-rocket"></i>
                            </div>
                            <h4 class="ms-4 mb-0">World-Class Education</h4>
                        </div>
                        <div>
                            <p class="mb-3">At ARNI University, we collaborate academic excellence with practical
                                knowledge to strengthen students for global success. We provide diverse programs,
                                advanced curriculum, and personalized support that ensure future growth.
                            </p>
                            <a href="/about-us" class="butn-style1 secondary">View More +</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-4 mt-1-9">
                <div class="card card-style3 h-100">
                    <div class="card-body px-1-9 py-2-3">
                        <div class="mb-3 d-flex align-items-center">
                            <div class="card-icon">
                                <i class="ti-world"></i>
                            </div>
                            <h4 class="ms-4 mb-0">Your Success, Our Commitment</h4>
                        </div>
                        <div>
                            <p class="mb-3">With dedicated personalized guidance, hands-on Internships, and
                                industry-aligned training, our goal is not just spreading book knowledge; we build
                                future leaders. Join the network of successful alumni and a rewarding career.</p>
                            <a href="/vision-and-mission" class="butn-style1 secondary">View More +</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-4 mt-1-9">
                <div class="card card-style3 h-100">
                    <div class="card-body px-1-9 py-2-3">
                        <div class="mb-3 d-flex align-items-center">
                            <div class="card-icon">
                                <i class="ti-user"></i>
                            </div>
                            <h4 class="ms-4 mb-0">Designed For Success</h4>
                        </div>
                        <div>
                            <p class="mb-3">From vibrant cultural space, ARNI’s campus offers an environment where
                                innovation thrives. Experience endless opportunities to excel in academics, and
                                participate in extracurriculars to create a lasting memory.</p>
                            <a href="/about-us" class="butn-style1 secondary">View More +</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- COUNTER
        ================================================== -->
<section class="icon-box-area pb-md-4 pt-md-4 mt-2">
    <div class="container my-5">
        <div class="card-container1 row">
            <div class="col-md-3 col-sm-12 mb-sm-3 mb-3">
                <div class="card1">
                    <h4><span class="countup text-white fs-1 text-primary mb-1">1800</span>+</h4>
                    <h3 class="text-primary mb-3">Student Strength</h3>
                    <h6 class="text-primary">A Flourishing Hub of Innovation </h6>
                </div>
            </div>
            <div class="col-md-3 col-sm-12 mb-sm-3 mb-3">
                <div class="card1">
                    <h4><span class="countup text-white fs-1 text-primary mb-1">200</span>+</h4>
                    <h3 class="text-primary mb-3 text-nowrap">Faculty Numbers</h3>
                    <h6 class="text-primary">Experienced Faculty Across All
                        Departments</h6>
                </div>
            </div>
            <div class="col-md-3 col-sm-12 mb-sm-3 mb-3">
                <div class="card1">
                    <h4><span class="countup text-white fs-1 text-primary mb-1">100</span>+</h4>
                    <h3 class="text-primary mb-3 text-nowrap">Programs Offered</h3>
                    <h6 class="text-primary"> Wide Range of Academic Offerings</h6>
                </div>
            </div>
            <div class="col-md-3 col-sm-12 mb-sm-3 mb-3">
                <div class="card1">
                    <h4><span class="countup text-white fs-1 text-primary mb-1">10</span>+</h4>
                    <h3 class="text-primary mb-3 text-nowrap">Campus Facilities</h3>
                    <h6 class="text-primary">State-of-the-Art Infrastructure &
                        Amenities</h6>
                </div>
            </div>
        </div>
    </div>
</section>


<!-- ABOUTUS
       ================================================== -->
<div class="parallax-container ">
    <div class="parallax-content text-center parallax-container-overlay">
        <div class="container pt-6 mb-5">
            <div class="row align-items-center ">
                <div class="col-md-12 col-lg-6 order-lg-1 pt-4 pt-md-0  ">
                    <img src="assets/img/content/home-page.png" alt="..."
                         class="img-fluid">
                </div>
                <div class="col-md-12 col-lg-6 mt-1-9 order-2 order-lg-1">
                    <div class="text-md-start text-center section-heading text-start mb-0 mb-md-2">
                        <span class="sub-title">welcome!</span>
                    </div>
                    <h2 class="mb-0 mb-md-2 text-md-start text-center font-weight-800 h1 text-secondary text-decoration-underline">
                        ABOUT ARNI</h2>
                    <blockquote class="text-white fs-6 text-start blur-background">
                        ARNI University is one of the leading Institutions in India for higher education, stands out for
                        its
                        unique blend of academic and technical excellence to its students. The University was
                        established in
                        2009, and recognized by UGC, India. With a diverse range of programs that emphasize versatility,
                        experiential learning, and interdisciplinary approaches, we are empowering modern learners to
                        transform their dreams into reality while nurturing students’ passions and guiding them toward
                        achieving success.
                        <br/>
                        At Arni University, we cultivate socially conscious individuals through a dynamic and
                        intellectually
                        enriching environment that celebrates diversity. Guided by the philosophy of "Skill
                        Comprehensive
                        Higher Education," we focus on creating sustainable opportunities across challenging regions of
                        the
                        country. By fostering employability and igniting the spirit of entrepreneurship, we prepare our
                        students to make meaningful contributions to society while shaping a brighter future for
                        themselves.
                    </blockquote>
                    <div class="dotted-seprator pt-1-9"></div>
                    <div class="row g-4">
                        <div class="col-sm-6 col-12 d-flex justify-content-center justify-content-md-start mb-sm-0 ">
                            <div class="media blur-background">
                                <i class="ti-mobile display-15 text-secondary"></i>
                                <div class="media-body align-self-center ms-3">
                                    <h4 class="mb-1 h5 text-white">Phone Number</h4>
                                    <p class="mb-0">1800 891 8962</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-12 d-flex justify-content-center justify-content-md-start ">
                            <div class="media  blur-background">
                                <i class="ti-email display-18 text-secondary"></i>
                                <div class="media-body align-self-center ms-3">
                                    <h4 class="mb-1 h5 text-white">Email Address</h4>
                                    <p class="mb-0 text-nowrap">info@arniuniversity.edu.in</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="shape18">
                <img src="assets/img/bg/bg-01.jpg" alt="...">
            </div>
            <div class="shape20">
                <img src="assets/img/bg/bg-02.jpg" alt="...">
            </div>
        </div>
    </div>
</div>

<!--School-->
<section class="">
    <div class=" text-center section-heading text-start mb-0 mb-md-2">
        <span class="sub-title">Schools</span>
    </div>
    <h2 class="mb-0 mb-md-2  text-center font-weight-800 h1 text-primary text-decoration-underline">
        ARNI SCHOOLS</h2>
    <div class="container mt-5" style="height: 300px;overflow: hidden;">
        <div id="carouselExampleIndicatorsSchools" class="carousel slide " data-bs-ride="carousel">
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <div class="row justify-content-center">
                        <div class="col-md-6 col-sm-12">
                            <div class="card2 w-100">
                                <div class="card-inner1" style="--clr:#fff;">
                                    <div class="box1">
                                        <div
                                            class="team-style1 text-center border-top border-5 border-color-secondary rounded-4">
                                            <img src="assets/img/schools/1.jpg"
                                                 class="border-radius-5 cover-background w-100"
                                                 alt="...">
                                            <div
                                                class="team-info bg-blur border-start border-4 border-color-secondary mb-15 overflow-hidden">
                                                <h3 class="text-primary h4">Arni School of Agriculture</h3>
                                            </div>
                                            <div
                                                class="team-overlay bg-primary border-start border-end border-2 border-color-secondary">
                                                <div class="row mt-3">
                                                    <div class="col-12 d-table">
                                                        <li class="alert alert-warning p-0 m-0 d-table-cell cursor-pointer"
                                                            role="alert"
                                                            (click)="goToUrl('/asa-agriculture')">Agriculture
                                                        </li>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="icon1 ">
                                            <a (click)="goToUrl('asa')"
                                               class="iconBox1 text-primary bg-secondary border border-2 border-color-primary cursor-pointer"><i
                                                class="fa fa-arrow-right"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <div class="card2 w-100">
                                <div class="card-inner1" style="--clr:#fff;">
                                    <div class="box1">
                                        <div
                                            class="team-style1 text-center border-top border-5 border-color-secondary rounded-4">
                                            <img src="assets/img/schools/2.jpg"
                                                 class="border-radius-5 cover-background w-100"
                                                 alt="...">
                                            <div
                                                class="team-info bg-blur border-start border-4 border-color-secondary mb-15 overflow-hidden">
                                                <h3 class="text-primary h4">Arni School of Allied Health Sciences</h3>
                                            </div>
                                            <div
                                                class="team-overlay bg-primary border-start border-end border-2 border-color-secondary">
                                                <div class="row mt-3">
                                                    <div class="col-12 d-table mb-1">
                                                        <li class="alert alert-warning p-0 m-0 d-table-cell cursor-pointer"
                                                            role="alert"
                                                            (click)="goToUrl('/asahs-radiology')">Radiology
                                                        </li>
                                                    </div>
                                                    <div class="col-12 d-table mb-1">
                                                        <li class="alert alert-warning p-0 m-0 d-table-cell cursor-pointer"
                                                            role="alert"
                                                            (click)="goToUrl('/asahs-ott')">Operation Theatre Technology
                                                        </li>
                                                    </div>
                                                    <div class="col-12 d-table mb-1">
                                                        <li class="alert alert-warning p-0 m-0 d-table-cell cursor-pointer"
                                                            role="alert"
                                                            (click)="goToUrl('/asahs-anesthesia')">Anesthesia
                                                        </li>
                                                    </div>
                                                    <div class="col-12 d-table mb-1">
                                                        <li class="alert alert-warning p-0 m-0 d-table-cell cursor-pointer"
                                                            role="alert"
                                                            (click)="goToUrl('/asahs-optometry')">Optometry
                                                        </li>
                                                    </div>
                                                    <div class="col-12 d-table mb-1">
                                                        <li class="alert alert-warning p-0 m-0 d-table-cell cursor-pointer"
                                                            role="alert"
                                                            (click)="goToUrl('/asahs-mlt')">Medical Lab Technology
                                                        </li>
                                                    </div>
                                                    <div class="col-12 d-table mb-1">
                                                        <li class="alert alert-warning p-0 m-0 d-table-cell cursor-pointer"
                                                            role="alert"
                                                            (click)="goToUrl('/asahs-physiotherapy')">Physiotherapy
                                                        </li>
                                                    </div>
                                                    <div class="col-12 d-table mb-1">
                                                        <li class="alert alert-warning p-0 m-0 d-table-cell cursor-pointer"
                                                            role="alert"
                                                            (click)="goToUrl('/asahs-yogasci')">Naturopathy & Yogic
                                                            Sciences
                                                        </li>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="icon1 ">
                                            <a (click)="goToUrl('asahs')"
                                               class="iconBox1 text-primary bg-secondary border border-2 border-color-primary cursor-pointer"><i
                                                class="fa fa-arrow-right"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="carousel-item">
                    <div class="row justify-content-center">
                        <div class="col-md-6 col-sm-12">
                            <div class="card2 w-100">
                                <div class="card-inner1" style="--clr:#fff;">
                                    <div class="box1">
                                        <div
                                            class="team-style1 text-center border-top border-5 border-color-secondary rounded-4">
                                            <img src="assets/img/schools/3.jpg"
                                                 class="border-radius-5 cover-background w-100"
                                                 alt="...">
                                            <div
                                                class="team-info bg-blur border-start border-4 border-color-secondary mb-15 overflow-hidden">
                                                <h3 class="text-primary h4">Arni School of Arts & Humanities</h3>
                                            </div>
                                            <div
                                                class="team-overlay bg-primary border-start border-end border-2 border-color-secondary">
                                                <div class="row mt-3">
                                                    <div class="col-12 d-table mb-1">
                                                        <li class="alert alert-warning p-0 m-0 d-table-cell cursor-pointer"
                                                            role="alert"
                                                            (click)="goToUrl('/asah-english')">English
                                                        </li>
                                                    </div>
                                                    <div class="col-12 d-table mb-1">
                                                        <li class="alert alert-warning p-0 m-0 d-table-cell cursor-pointer"
                                                            role="alert"
                                                            (click)="goToUrl('/asah-education')">Education
                                                        </li>
                                                    </div>
                                                    <div class="col-12 d-table mb-1">
                                                        <li class="alert alert-warning p-0 m-0 d-table-cell cursor-pointer"
                                                            role="alert"
                                                            (click)="goToUrl('/asah-library-science')">Library Science
                                                        </li>
                                                    </div>
                                                    <div class="col-12 d-table mb-1">
                                                        <li class="alert alert-warning p-0 m-0 d-table-cell cursor-pointer"
                                                            role="alert"
                                                            (click)="goToUrl('/asah-journalism-and-mass-communication')">
                                                            Journalism
                                                            & Mass
                                                            Communication
                                                        </li>
                                                    </div>
                                                    <div class="col-12 d-table mb-1">
                                                        <li class="alert alert-warning p-0 m-0 d-table-cell cursor-pointer"
                                                            role="alert"
                                                            (click)="goToUrl('/asah-fashion-design')">Design
                                                        </li>
                                                    </div>
                                                    <div class="col-12 d-table mb-1">
                                                        <li class="alert alert-warning p-0 m-0 d-table-cell cursor-pointer"
                                                            role="alert"
                                                            (click)="goToUrl('/asah-yoga-science')">Yoga Science
                                                        </li>
                                                    </div>
                                                    <div class="col-12 d-table mb-1">
                                                        <li class="alert alert-warning p-0 m-0 d-table-cell cursor-pointer"
                                                            role="alert"
                                                            (click)="goToUrl('/asah-vocational-course')">Vocational
                                                            Courses
                                                        </li>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="icon1 ">
                                            <a (click)="goToUrl('asah')"
                                               class="iconBox1 text-primary bg-secondary border border-2 border-color-primary cursor-pointer"><i
                                                class="fa fa-arrow-right"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <div class="card2 w-100">
                                <div class="card-inner1" style="--clr:#fff;">
                                    <div class="box1">
                                        <div
                                            class="team-style1 text-center border-top border-5 border-color-secondary rounded-4">
                                            <img src="assets/img/schools/4.jpg"
                                                 class="border-radius-5 cover-background w-100"
                                                 alt="...">
                                            <div
                                                class="team-info bg-blur border-start border-4 border-color-secondary mb-15 overflow-hidden">
                                                <h3 class="text-primary h4">Arni School of Business Management &
                                                    Commerce</h3>
                                            </div>
                                            <div
                                                class="team-overlay bg-primary border-start border-end border-2 border-color-secondary">
                                                <div class="row mt-3">
                                                    <div class="col-12 d-table mb-1">
                                                        <li class="alert alert-warning p-0 m-0 d-table-cell cursor-pointer"
                                                            role="alert"
                                                            (click)="goToUrl('/asbmc-business-studies')">BusinessStudies
                                                        </li>
                                                    </div>
                                                    <div class="col-12 d-table mb-1">
                                                        <li class="alert alert-warning p-0 m-0 d-table-cell cursor-pointer"
                                                            role="alert"
                                                            (click)="goToUrl('/asbmc-commerce')">Commerce
                                                        </li>
                                                    </div>
                                                    <div class="col-12 d-table mb-1">
                                                        <li class="alert alert-warning p-0 m-0 d-table-cell cursor-pointer"
                                                            role="alert"
                                                            (click)="goToUrl('/asbmc-hospitality-management')">
                                                            Hospitality
                                                            Management
                                                        </li>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="icon1 ">
                                            <a (click)="goToUrl('asbmc')"
                                               class="iconBox1 text-primary bg-secondary border border-2 border-color-primary cursor-pointer"><i
                                                class="fa fa-arrow-right"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="carousel-item">
                    <div class="row justify-content-center">
                        <div class="col-md-6 col-sm-12">
                            <div class="card2 w-100">
                                <div class="card-inner1" style="--clr:#fff;">
                                    <div class="box1">
                                        <div
                                            class="team-style1 text-center border-top border-5 border-color-secondary rounded-4">
                                            <img src="assets/img/schools/5.jpg"
                                                 class="border-radius-5 cover-background w-100"
                                                 alt="...">
                                            <div
                                                class="team-info bg-blur border-start border-4 border-color-secondary mb-15 overflow-hidden">
                                                <h3 class="text-primary h4">Arni School of Education & Sports</h3>
                                            </div>
                                            <div
                                                class="team-overlay bg-primary border-start border-end border-2 border-color-secondary">
                                                <div class="row mt-3">
                                                    <div class="col-12 d-table mb-1">
                                                        <li class="alert alert-warning p-0 m-0 d-table-cell cursor-pointer"
                                                            role="alert"
                                                            (click)="goToUrl('/ases-physical-application')">Sports
                                                        </li>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="icon1 ">
                                            <a (click)="goToUrl('ases')"
                                               class="iconBox1 text-primary bg-secondary border border-2 border-color-primary cursor-pointer"><i
                                                class="fa fa-arrow-right"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <div class="card2 w-100">
                                <div class="card-inner1" style="--clr:#fff;">
                                    <div class="box1">
                                        <div
                                            class="team-style1 text-center border-top border-5 border-color-secondary rounded-4">
                                            <img src="assets/img/schools/6.jpg"
                                                 class="border-radius-5 cover-background w-100"
                                                 alt="...">
                                            <div
                                                class="team-info bg-blur border-start border-4 border-color-secondary mb-15 overflow-hidden">
                                                <h3 class="text-primary h4">Arni School of Basic Sciences &
                                                    Bio-Technology</h3>
                                            </div>
                                            <div
                                                class="team-overlay bg-primary border-start border-end border-2 border-color-secondary">
                                                <div class="row mt-3">
                                                    <div class="col-12 d-table mb-1">
                                                        <li class="alert alert-warning p-0 m-0 d-table-cell cursor-pointer"
                                                            role="alert"
                                                            (click)="goToUrl('/asbsbt-physical-science')">Physics
                                                        </li>
                                                    </div>
                                                    <div class="col-12 d-table mb-1">
                                                        <li class="alert alert-warning p-0 m-0 d-table-cell cursor-pointer"
                                                            role="alert"
                                                            (click)="goToUrl('/asbsbt-life-science')">Life Science
                                                        </li>
                                                    </div>
                                                    <div class="col-12 d-table mb-1">
                                                        <li class="alert alert-warning p-0 m-0 d-table-cell cursor-pointer"
                                                            role="alert"
                                                            (click)="goToUrl('/asbsbt-chemistry')">Chemistry
                                                        </li>
                                                    </div>
                                                    <div class="col-12 d-table mb-1">
                                                        <li class="alert alert-warning p-0 m-0 d-table-cell cursor-pointer"
                                                            role="alert"
                                                            (click)="goToUrl('/asbsbt-maths')">Maths
                                                        </li>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="icon1 ">
                                            <a (click)="goToUrl('asbsbt')"
                                               class="iconBox1 text-primary bg-secondary border border-2 border-color-primary cursor-pointer"><i
                                                class="fa fa-arrow-right"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="carousel-item">
                    <div class="row justify-content-center">
                        <div class="col-md-6 col-sm-12">
                            <div class="card2 w-100">
                                <div class="card-inner1" style="--clr:#fff;">
                                    <div class="box1">
                                        <div
                                            class="team-style1 text-center border-top border-5 border-color-secondary rounded-4">
                                            <img src="assets/img/schools/7.jpg"
                                                 class="border-radius-5 cover-background w-100"
                                                 alt="...">
                                            <div
                                                class="team-info bg-blur border-start border-4 border-color-secondary mb-15 overflow-hidden">
                                                <h3 class="text-primary h4">Arni School of Law</h3>
                                            </div>
                                            <div
                                                class="team-overlay bg-primary border-start border-end border-2 border-color-secondary">
                                                <div class="row mt-3">
                                                    <div class="col-12 d-table mb-1">
                                                        <li class="alert alert-warning p-0 m-0 d-table-cell cursor-pointer"
                                                            role="alert"
                                                            (click)="goToUrl('/asl-legal-studies')">Legal Studies
                                                        </li>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="icon1 ">
                                            <a (click)="goToUrl('asl')"
                                               class="iconBox1 text-primary bg-secondary border border-2 border-color-primary cursor-pointer"><i
                                                class="fa fa-arrow-right"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <div class="card2 w-100">
                                <div class="card-inner1" style="--clr:#fff;">
                                    <div class="box1">
                                        <div
                                            class="team-style1 text-center border-top border-5 border-color-secondary rounded-4">
                                            <img src="assets/img/schools/8.jpg"
                                                 class="border-radius-5 cover-background w-100"
                                                 alt="...">
                                            <div
                                                class="team-info bg-blur border-start border-4 border-color-secondary mb-15 overflow-hidden">
                                                <h3 class="text-primary h4">Arni School of Pharmacy</h3>
                                            </div>
                                            <div
                                                class="team-overlay bg-primary border-start border-end border-2 border-color-secondary">
                                                <div class="row mt-3">
                                                    <div class="col-12 d-table mb-1">
                                                        <li class="alert alert-warning p-0 m-0 d-table-cell cursor-pointer"
                                                            role="alert"
                                                            (click)="goToUrl('/asp-pharmacy')">Pharmacy
                                                        </li>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="icon1 ">
                                            <a (click)="goToUrl('asp')"
                                               class="iconBox1 text-primary bg-secondary border border-2 border-color-primary cursor-pointer"><i
                                                class="fa fa-arrow-right"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="carousel-item">
                    <div class="row justify-content-center">
                        <div class="col-md-6 col-sm-12">
                            <div class="card2 w-100">
                                <div class="card-inner1" style="--clr:#fff;">
                                    <div class="box1">
                                        <div
                                            class="team-style1 text-center border-top border-5 border-color-secondary rounded-4">
                                            <img src="assets/img/schools/9.jpg"
                                                 class="border-radius-5 cover-background w-100"
                                                 alt="...">
                                            <div
                                                class="team-info bg-blur border-start border-4 border-color-secondary mb-15 overflow-hidden">
                                                <h3 class="text-primary h4">Arni School of Technology</h3>
                                            </div>
                                            <div
                                                class="team-overlay bg-primary border-start border-end border-2 border-color-secondary">
                                                <div class="row mt-3">
                                                    <div class="col-12 d-table mb-1">
                                                        <li class="alert alert-warning p-0 m-0 d-table-cell cursor-pointer"
                                                            role="alert"
                                                            (click)="goToUrl('/ases-physical-application')">Civil
                                                            Engineering
                                                        </li>
                                                    </div>
                                                    <div class="col-12 d-table mb-1">
                                                        <li class="alert alert-warning p-0 m-0 d-table-cell cursor-pointer"
                                                            role="alert"
                                                            (click)="goToUrl('/ases-physical-application')">Mechanical
                                                            Engineering
                                                        </li>
                                                    </div>
                                                    <div class="col-12 d-table mb-1">
                                                        <li class="alert alert-warning p-0 m-0 d-table-cell cursor-pointer"
                                                            role="alert"
                                                            (click)="goToUrl('/ases-physical-application')">Computer
                                                            Science
                                                            Engineering
                                                        </li>
                                                    </div>
                                                    <div class="col-12 d-table mb-1">
                                                        <li class="alert alert-warning p-0 m-0 d-table-cell cursor-pointer"
                                                            role="alert"
                                                            (click)="goToUrl('/ases-physical-application')">Computer
                                                            Science &
                                                            Applicaton
                                                        </li>
                                                    </div>
                                                    <div class="col-12 d-table mb-1">
                                                        <li class="alert alert-warning p-0 m-0 d-table-cell cursor-pointer"
                                                            role="alert"
                                                            (click)="goToUrl('/ases-physical-application')">ECE & EE
                                                        </li>
                                                    </div>
                                                    <div class="col-12 d-table mb-1">
                                                        <li class="alert alert-warning p-0 m-0 d-table-cell cursor-pointer"
                                                            role="alert"
                                                            (click)="goToUrl('/ases-physical-application')">Cyber
                                                            Security & AI
                                                        </li>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="icon1 ">
                                            <a (click)="goToUrl('ast')"
                                               class="iconBox1 text-primary bg-secondary border border-2 border-color-primary cursor-pointer"><i
                                                class="fa fa-arrow-right"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <div class="card2 w-100">
                                <div class="card-inner1" style="--clr:#fff;">
                                    <div class="box1">
                                        <div
                                            class="team-style1 text-center border-top border-5 border-color-secondary rounded-4">
                                            <img src="assets/img/schools/10.jpg"
                                                 class="border-radius-5 cover-background w-100"
                                                 alt="...">
                                            <div
                                                class="team-info bg-blur border-start border-4 border-color-secondary mb-15 overflow-hidden">
                                                <h3 class="text-primary h4">Arni School of Education & Sports</h3>
                                            </div>
                                            <div
                                                class="team-overlay bg-primary border-start border-end border-2 border-color-secondary">
                                                <div class="row mt-3">
                                                    <div class="col-12 d-table mb-1">
                                                        <li class="alert alert-warning p-0 m-0 d-table-cell cursor-pointer"
                                                            role="alert"
                                                            (click)="goToUrl('/ases-physical-application')">Sports
                                                        </li>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="icon1 ">
                                            <a (click)="goToUrl('ases')"
                                               class="iconBox1 text-primary bg-secondary border border-2 border-color-primary cursor-pointer"><i
                                                class="fa fa-arrow-right"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <span type="button" data-bs-target="#carouselExampleIndicatorsSchools"
                  data-bs-slide="prev" class="carousel-control-prev carousel-control-prev-icon"
                  aria-hidden="true" style="margin-top: 10px;overflow: hidden;"></span>
            <span type="button" data-bs-target="#carouselExampleIndicatorsSchools"
                  data-bs-slide="next" class="carousel-control-next carousel-control-next-icon"
                  aria-hidden="true" style="margin-top: 10px;overflow: hidden;"></span>
        </div>
    </div>
</section>

<!--placement section-->
<section class="m-0 p-0">
    <div class="container">
        <div class="section-heading text-center">
            <span class="sub-title">Alumni</span>
            <h2 class="mb-0 mb-md-2  text-center font-weight-800 h1 text-primary text-decoration-underline">
                ARNI ALUMNI</h2>
            <p class="text-white fs-5 font-weight-600 text-primary">At Arni University, we take pride in our diverse and
                accomplished alumni
                network. Our graduates have
                excelled in various industries worldwide, contributing to innovation and societal growth. We foster
                lifelong connections, providing a platform for alumni to engage, share experiences, and inspire the next
                generation. Whether leading global organizations or driving change in their communities, our alumni
                continue to uphold the values and vision of Arni University.</p>
        </div>
    </div>

    <div class="container-fluid">
        <div class="row justify-content-center alumni-height" style="">
            <div class="col-md-9 col-sm-12">
                <div id="carouselExampleIndicatorsPlacement"
                     class="carousel  slide "
                     data-bs-ride="carousel">
                    <button class="carousel-control-prev text-black" type="button"
                            data-bs-target="#carouselExampleIndicatorsPlacement"
                            data-bs-slide="prev">
                        <!--                        <span class="carousel-control-prev-icon pb-5" aria-hidden="true"></span>-->
                        <i class="fa fa-arrow-circle-left fs-4 mb-24"></i>
                    </button>
                    <button class="carousel-control-next text-black" type="button"
                            data-bs-target="#carouselExampleIndicatorsPlacement"
                            data-bs-slide="next">
                        <i class="fa fa-arrow-circle-right fs-4 mb-24"></i>
                        <!--                        <span class="carousel-control-next-icon" aria-hidden="true"></span>-->
                    </button>
                    <div class="carousel-inner text-center">
                        <div *ngFor="let alumniData of alumni;let i = index;" [ngClass]="{'active':(i==0)}"
                             class="carousel-item">
                            <div class="row">
                                <div *ngFor="let innerData of alumniData;let j = index;" class="col-md-6 col-sm-12">
                                    <img src="{{innerData?.file?.url}}" class="rounded w-100 h-50 mb-3"
                                         alt="{{i}} - {{j}}">
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="triangle-shape top-15 right-10 z-index-9 d-none d-md-block"></div>
    <div class="square-shape top-25 left-5 z-index-9 d-none d-xl-block"></div>
    <div class="shape-five z-index-9 right-10 bottom-15"></div>

</section>

<!-- EVENT DETAILS
   ================================================== -->
<section class="courses mt-0 pt-5 pb-5 information-section">
    <div class="container">
        <div class="section-heading mt-0">
            <span class="sub-title">Latest</span>
            <h2 class="h1 mb-0">INFORMATION</h2>


        </div>
        <div class="row">
            <!--  start courses list left-->
            <div class="col-md-12 col-lg-8 mb-2-9 mb-lg-0 ">
                <div class="ps-lg-1-6 ps-xl-1-9 ">
                    <div class="sidebar bg-blur rounded">
                        <div class="widget h-100">
                            <div class="widget-title">
                                <h3>Academic News</h3>
                            </div>
                            <marquee behavior="scroll" direction="up" onmouseover="this.stop();"
                                     onmouseout="this.start();" style="height: 300px">
                                <div class="single-item border-primary p-3 text-secondary">
                                    <div class="single-item-text cursor-pointer" *ngFor="let item of newsData;"
                                         (click)="goTo('news')">
                                        <h5><a href="assets/pdf/PHDSyllabusforentrance.pdf"
                                               target="_blank"> {{ item?.title }}</a></h5>
                                        <hr>
                                        <p class="text-primary">{{ item?.description }}
                                            Date : {{ item?.date }}</p>
                                    </div>
                                </div>
                            </marquee>
                        </div>
                    </div>
                </div>
            </div>
            <!--  end courses list left-->

            <!--  start courses list right-->
            <div class="col-md-12 col-lg-4">
                <div class="ps-lg-1-6 ps-xl-1-9">
                    <div class="sidebar bg-blur rounded">
                        <div class="widget h-100">
                            <div class="widget-title">
                                <h3>Notice</h3>
                            </div>
                            <marquee behavior="scroll" direction="up" onmouseover="this.stop();"
                                     onmouseout="this.start();" style="height: 300px">
                                <div class="single-item  border-primary p-3 text-secondary cursor-pointer"
                                     *ngFor="let notice of noticeData;">
                                    <div class="single-item-text">
                                        <h6 (click)="goTo(notice.url)"><i class="fa fa-star"></i> {{ notice?.heading }}
                                        </h6>
                                        <hr>
                                    </div>
                                </div>
                            </marquee>
                        </div>
                    </div>
                </div>
            </div>
            <!--  end courses list right-->
        </div>
    </div>
</section>


<!-- COUNTER
        ================================================== -->
<section class="pt-5 ">
    <div class="container ">
        <div class="section-heading">
            <h2 class="h1 mb-0">IMPORTANT FACTS</h2>
        </div>
        <div class="row mt-n1-9 text-center ">
            <div class="justify-content-center justify-content-md-start d-flex col-sm-6 col-lg-2 mt-1-9">
                <div class="counter-wrapper text-center">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-01.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">200</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">FACULTY</p>
                    </div>
                </div>
            </div>
            <div class="justify-content-center justify-content-md-start d-flex  col-sm-6 col-lg-2 mt-1-9 ">
                <div class="counter-wrapper">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-02.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">1800</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">STUDENTS</p>
                    </div>
                </div>
            </div>
            <div class="justify-content-center justify-content-md-start d-flex col-sm-6 col-lg-2 mt-1-9">
                <div class="counter-wrapper">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-03.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">7000</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">ALUMNI</p>
                    </div>
                </div>
            </div>
            <div class="justify-content-center justify-content-md-start d-flex col-sm-6 col-lg-2 mt-1-9">
                <div class="counter-wrapper">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-04.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">4</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">HOSTELS</p>
                    </div>
                </div>
            </div>
            <div class="justify-content-center justify-content-md-start d-flex  col-sm-6 col-lg-2 mt-1-9 ">
                <div class="counter-wrapper text-center ">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-04.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">500</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">RESEARCH PAPERS</p>
                    </div>
                </div>
            </div>
            <div class="justify-content-center justify-content-md-start d-flex  col-sm-6 col-lg-2 mt-1-9 ">
                <div class="counter-wrapper text-center">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-04.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">10</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Schools</p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>

<!-- TESTIMONIAL
        ================================================== -->
<section class="bg-light my-0 py-0">
    <section class="parallax-container-testimonial p-0 m-0 ">
        <div class="parallax-container-overlay-testimonial p-0 m-0 py-5">
            <div class="container mt-5 mb-5">
                <div class="section-heading">
                    <div
                        class="text-md-start text-center section-heading text-start mb-0 mb-md-2 d-flex justify-content-center">
                        <span class="sub-title">Testimonial</span>
                    </div>
                </div>
                <div id="carouselExampleIndicatorsTestimonial"
                     class="carousel  slide testimonial-height"
                     data-bs-ride="carousel">
                    <button class="carousel-control-prev text-black" type="button"
                            data-bs-target="#carouselExampleIndicatorsTestimonial"
                            data-bs-slide="prev" style="margin-top: -140px;">
                        <i class="fa fa-arrow-circle-left fs-4 mb-24 text-info"></i>
                    </button>
                    <button class="carousel-control-next text-black" type="button"
                            data-bs-target="#carouselExampleIndicatorsTestimonial"
                            data-bs-slide="next" style="margin-top: -140px;">
                        <i class="fa fa-arrow-circle-right fs-4 mb-24 text-info"></i>
                    </button>
                    <div class="carousel-inner text-center">
                        <div *ngFor="let testimonial of testimonials;let i = index;" [ngClass]="{'active':(i==0)}"
                             class="carousel-item">
                            <div class="row">
                                <div class="col-md-4 col-sm-12 mb-3"
                                     *ngFor="let innerData of testimonial;let j = index;">
                                    <div class="container1">
                                        <div class="card front-face">
                                            <div class="row  justify-content-center">
                                                <div class="col-12 text-center mb-0 pb-0">
                                                    <p class="text-white">ARNI Student</p>
                                                </div>
                                                <div class="col-12 text-center">
                                                    <img class="rounded-image"
                                                         src="{{innerData?.file?.url}}"
                                                         alt="Card image cap">
                                                </div>
                                                <div class="col-12 text-center">
                                                    <p class="text-white">{{ innerData?.name }}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card back-face ">
                                            <p class="text-white">{{ innerData?.description?.length > 240 ? innerData?.description?.slice(0, 240)+'...' : innerData?.description }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <div class="shape21">
        <img src="assets/img/bg/bg-03.jpg" alt="...">
    </div>
</section>

<!-- collaboration
        ================================================== -->
<section class="pt-4">
    <div class="container">
        <div class="section-heading">
            <h2 class="h1 mb-0">OUR COLLABORATION</h2>
        </div>
        <div class="row g-5 justify-content-center justify-content-md-start">

            <div class="col-lg-3 col-xl-3 col-md-6 col-sm-12 ">
                <div class="card mx-auto border rounded border-3 border-double border-color-primary p-3"
                     style="width: 18rem;height: 19rem;">
                    <img class="card-img-top border rounded border-radius-30 border-2 border-secondary border-dashed"
                         src="assets/img/collab/collab_1.png" alt="Card image cap"
                         style="width: 289px;height: 161px;">
                    <div class="card-body">
                        <span class="card-title text-decoration-underline">Campus World</span>
                        <p class="card-text" style="font-size: 15px;">Collaboration with Campus World</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-xl-3 col-md-6 col-sm-12">
                <div class="card mx-auto border rounded border-3 border-double border-color-primary p-3"
                     style="width: 18rem;height: 19rem;">
                    <img class="card-img-top border rounded border-radius-30 border-2 border-secondary border-dashed"
                         src="assets/img/collab/collab_2.jpg" alt="Card image cap"
                         style="width: 289px;height: 161px;">
                    <div class="card-body">
                        <span class="card-title text-decoration-underline">Media & Entertainment
                            Skills Council</span>
                        <p class="card-text" style="font-size: 15px;">Collaboration with Media & Entertainment Skills
                            Council</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-xl-3 col-md-6 col-sm-12">
                <div class="card mx-auto border rounded border-3 border-double border-color-primary p-3"
                     style="width: 18rem;height: 19rem;">
                    <img class="card-img-top border rounded border-radius-30 border-2 border-secondary border-dashed"
                         src="assets/img/collab/collab_3.png" alt="Card image cap"
                         style="width: 289px;height: 161px;">
                    <div class="card-body">
                        <span class="card-title text-decoration-underline">Aspire</span>
                        <p class="card-text" style="font-size: 15px;">Collaboration with Aspire Business School
                            Barcelona</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-xl-3 col-md-6 col-sm-12">
                <div class="card mx-auto border rounded border-3 border-double border-color-primary p-3"
                     style="width: 18rem;height: 19rem;">
                    <img class="card-img-top border rounded border-radius-30 border-2 border-secondary border-dashed"
                         src="assets/img/collab/collab_4.jpg" alt="Card image cap"
                         style="width: 289px;height: 161px;">
                    <div class="card-body">
                        <span class="card-title text-decoration-underline">CGIA</span>
                        <p class="card-text" style="font-size: 15px;">Collaboration with CGIA Institute</p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>


<section id="company-hiring" class="section display-block-phone">
    <div class="container">
        <!--    <a href="#!" class="btn button3 view-all">View
                all companies...</a>-->
        <h2>COMPANIES HIRING</h2>
        <p class="lead">Top companies are hiring from arni</p>

        <div class="stats-bg clearfix">
            <div class="animate">
                <ul class="clearfix">
                    <li><img class="" data-src="assets/img/companies/hcl.png" alt="logo"
                             src="assets/img/companies/hcl.png"></li>
                    <li><img class="" data-src="assets/img/companies/syntel2.png" alt="logo"
                             src="assets/img/companies/syntel2.png"></li>
                    <li><img class="" data-src="assets/img/companies/amarujala.png" alt="logo"
                             src="assets/img/companies/amarujala.png"></li>
                    <li><img class="" data-src="assets/img/companies/Vodafone_logo.png" alt="logo"
                             src="assets/img/companies/Vodafone_logo.png"></li>
                    <li><img class="" data-src="assets/img/companies/cmc-logo_0.png" alt="logo"
                             src="assets/img/companies/cmc-logo_0.png"></li>
                    <li><img class="" data-src="assets/img/companies/FutureGroup.png" alt="logo"
                             src="assets/img/companies/FutureGroup.png"></li>
                    <li><img class="" data-src="assets/img/companies/sleepwell.png" alt="logo"
                             src="assets/img/companies/sleepwell.png"></li>
                    <li><img class="" data-src="assets/img/companies/Tech_Mahindra_New_Logo1.png" alt="logo"
                             src="assets/img/companies/Tech_Mahindra_New_Logo1.png"></li>
                    <li><img class="" data-src="assets/img/companies/Amazon.png" alt="logo"
                             src="assets/img/companies/Amazon.png"></li>
                    <li><img class="" data-src="assets/img/companies/zenpact.png" alt="logo"
                             src="assets/img/companies/zenpact.png"></li>
                    <li><img class="" data-src="assets/img/companies/adani_wilmar.png" alt="logo"
                             src="assets/img/companies/adani_wilmar.png"></li>
                    <li><img class="" data-src="assets/img/companies/Dish_TV_2.png" alt="logo"
                             src="assets/img/companies/Dish_TV_2.png"></li>
                    <li><img class="" data-src="assets/img/companies/niit_logo_03.png" alt="logo"
                             src="assets/img/companies/niit_logo_03.png"></li>
                    <li><img class="" data-src="assets/img/companies/icici_securities.png" alt="logo"
                             src="assets/img/companies/icici_securities.png"></li>
                    <li><img class="" data-src="assets/img/companies/Zee_TV_2011.png" alt="logo"
                             src="assets/img/companies/Zee_TV_2011.png"></li>
                    <li><img class="" data-src="assets/img/companies/Zee_TV_2011.png" alt="logo"
                             src="assets/img/companies/Zee_TV_2011.png"></li>
                </ul>
            </div>
            <div class="round round1">
                <span class="sm-round"></span>
                <div class="content">
                    <figure>
                        <img class="" data-src="assets/img/companies/icon2.png" alt="icon"
                             src="assets/img/companies/icon2.png">
                    </figure>
                    <h4>65% to 100% </h4>
                    <p>Placement program wise</p>
                    <!--<h4>Upto 100%</h4>
                    <p>Placement Assistance</p>-->
                </div>
            </div>
            <div class="round round2">
                <span class="sm-round"></span>
                <div class="content">
                    <figure>
                        <img class="" data-src="assets/img/companies/icon3.png" alt="icon"
                             src="assets/img/companies/icon3.png">
                    </figure>
                    <h4>26000+</h4>

                    <p>Successful Alumni worldwide</p>
                </div>
            </div>
            <div class="round round3">
                <span class="sm-round"></span>
                <div class="content">
                    <figure>
                        <img class="" data-src="assets/img/companies/icon1.png" alt="icon"
                             src="assets/img/companies/icon1.png">
                    </figure>
                    <h4>600+</h4>

                    <p>companies hiring world wide</p>
                </div>
            </div>
        </div>
    </div>
</section>
